// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { teacupWithHelpers } from 'app/scripts/views/internal/teacupWithHelpers';

import '../../../stylesheets/components/views/board/board-copy-template.less';

const t = teacupWithHelpers('board_copy');

export const BoardCopyTemplate = () => {
  t.mustacheBlock('loading', () => t.div('.spinner.loading'));
  return t.mustacheBlockInverted('loading', () =>
    t.form(
      function () {
        t.label({ for: 'boardNewTitle' }, () => t.format('title'));
        t.input('.non-empty.js-autofocus', {
          id: 'boardNewTitle',
          type: 'text',
          name: 'name',
          placeholder: t.mustacheVar('placeholder'),
          value: t.mustacheVar('boardNameInputValue'),
          dir: 'auto',
        });

        t.div({ class: t.mustacheBlock('hideOrg', () => 'hide') }, function () {
          t.div('.u-clearfix', function () {
            return t.label(
              '.u-float-left',
              { style: 'margin-right: 8px;' },
              () => t.format('organization'),
            );
          });

          t.mustacheBlock('hasEnterprise', () =>
            t.mustacheBlock('enterpriseName', function () {
              if (!t.mustacheVar('showPrivateBoardsOptionForEntBoards')) {
                return t.p('.quiet', () =>
                  t.format('board-can-only-be-copied-to-teams-within-org', {
                    enterpriseName: t.mustacheVar('enterpriseName'),
                  }),
                );
              }
            }),
          );

          return t.select(
            {
              name: 'org-id',
              class: t.mustacheBlockInverted('canAddToOrgs', () => 'hide'),
            },
            function () {
              return t.mustacheBlock('orgs', () =>
                t.optionSelected(
                  t.mustacheVar('selectOrg'),
                  { value: t.mustacheVar('id') },
                  () => t.text(t.mustacheVar('displayName')),
                ),
              );
            },
          );
        });

        t.div('.board-limits-upgrade-ad.js-board-limits-upgrade-ad.hide', () =>
          t.p(function () {
            if (t.mustacheVar('isDesktop')) {
              return t.format(
                'board-cant-be-copied-because-of-board-limits-desktop',
              );
            } else {
              return t.div('.copy-board-upsell-react-component');
            }
          }),
        );

        t.div('.js-permissions.hide', function () {
          t.input({
            type: 'hidden',
            name: 'permissionLevel',
            value: t.mustacheVar('pLevel'),
          });

          t.p('.quiet.js-vis-display');

          t.ul('.pop-over-list.js-vis-chooser.hide');

          t.p('.error.js-no-valid-org-privs.u-clearfix.hide');

          t.div('.js-confirm-public-message.hide', function () {
            t.p(t.mustacheVar('publicConfirmationText'));
            t.input(
              '.pop-over-confirmation-button.nch-button.nch-button--primary.js-confirm-public',
              {
                type: 'button',
                value: t.mustacheVar('publicConfirmationConfirm'),
              },
            );
            return t.input('.pop-over-confirmation-button.js-cancel-public', {
              type: 'button',
              value: t.mustacheVar('publicConfirmationCancel'),
            });
          });

          t.div('.check-group', function () {
            t.div(
              '.check-div.u-clearfix',
              { style: 'margin-top: 10px;' },
              function () {
                t.input({
                  type: 'checkbox',
                  id: 'idKeepCards',
                  name: 'cards',
                  checked: true,
                });
                return t.label({ for: 'idKeepCards' }, () =>
                  t.format('keep-cards'),
                );
              },
            );
            return t.div(
              '.check-div.u-clearfix',
              { style: 'margin-top: 10px;' },
              function () {
                t.input({
                  type: 'checkbox',
                  id: 'idKeepTemplateCards',
                  name: 'templates',
                  checked: true,
                });
                return t.label({ for: 'idKeepTemplateCards' }, () =>
                  t.format('keep-template-cards'),
                );
              },
            );
          });
          t.p('.quiet', () =>
            t.format('activity-and-members-will-not-be-copied'),
          );

          t.p('.js-custom-fields-disabled-warning.quiet.hide');
        });

        t.div('.js-read-only-workspace-upsell');

        return t.input(
          '.nch-button.nch-button--primary.wide.js-submit.disabled',
          {
            type: 'submit',
            value: t.l('create'),
          },
        );
      },
      {
        class: 'board-copy-from-template',
      },
    ),
  );
};
